const requestActionTypes = {
  RESET_STATE: 'RESET_STATE',
  REQUEST_USERNAME_REQUEST: 'REQUEST_USERNAME_REQUEST',
  REQUEST_USERNAME_SUCCESS: 'REQUEST_USERNAME_SUCCESS',
  REQUEST_USERNAME_FAILURE: 'REQUEST_USERNAME_FAILURE',
};

export { requestActionTypes as default };
